export default __webpack_public_path__ + "static/media/crm_img2.dd466602.jpg";